module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container-wrapper"
  }, [_c('div', {
    staticClass: "breadcrumb-wrapper"
  }, [_c('span', [_vm._v("主题跑 / 新增")]), _vm._v(" "), _c('el-button', {
    staticClass: "back",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-wrapper"
  }, [_c('el-form', {
    ref: "formRef",
    attrs: {
      "label-width": "145px",
      "label-position": "left",
      "model": _vm.formData,
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入名称",
      "disabled": !_vm.isOperable
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "排序"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 1,
      "disabled": !_vm.isOperable
    },
    model: {
      value: (_vm.formData.orderNum),
      callback: function($$v) {
        _vm.$set(_vm.formData, "orderNum", $$v)
      },
      expression: "formData.orderNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动H5",
      "prop": "jumpUrl"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.isOperable
    },
    model: {
      value: (_vm.formData.jumpUrl),
      callback: function($$v) {
        _vm.$set(_vm.formData, "jumpUrl", $$v)
      },
      expression: "formData.jumpUrl"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "图片",
      "prop": "multipleImage"
    }
  }, [_c('div', {
    staticClass: "flex-row-between"
  }, [_c('div', {
    staticStyle: {
      "width": "30%"
    }
  }, [_c('div', [_vm._v("列表图")]), _vm._v(" "), _c('UploadImage', {
    attrs: {
      "actionUrl": "/adminapi/v1/basicTools/upload/one?uploadImageType=3",
      "tips": "（尺寸：，jpg、png、gif）",
      "urls": _vm.formData.listImg,
      "readonly": !_vm.isOperable
    },
    on: {
      "onUrls": _vm.listImgUploaded
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "30%"
    }
  }, [_c('div', [_vm._v("活动介绍图")]), _vm._v(" "), _c('UploadImage', {
    attrs: {
      "actionUrl": "/adminapi/v1/basicTools/upload/one?uploadImageType=3",
      "tips": "（尺寸：，jpg、png、gif）",
      "urls": _vm.formData.url,
      "readonly": !_vm.isOperable
    },
    on: {
      "onUrls": _vm.introduceImgUploaded
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "30%"
    }
  }, [_c('div', [_vm._v("跑步记录背景图")]), _vm._v(" "), _c('UploadImage', {
    attrs: {
      "actionUrl": "/adminapi/v1/basicTools/upload/one?uploadImageType=3",
      "tips": "（尺寸：，jpg、png、gif）",
      "urls": _vm.formData.backgroundImg,
      "readonly": !_vm.isOperable
    },
    on: {
      "onUrls": _vm.backgroundImgUploaded
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex-row-between margin-top-20"
  }, [_c('div', {
    staticStyle: {
      "width": "30%"
    }
  }, [_c('div', [_vm._v("奖牌图（非必填）")]), _vm._v(" "), _c('UploadImage', {
    attrs: {
      "actionUrl": "/adminapi/v1/basicTools/upload/one?uploadImageType=3",
      "urls": _vm.formData.prizeImg,
      "readonly": !_vm.isOperable
    },
    on: {
      "onUrls": _vm.prizeImgUploaded
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "30%"
    }
  }, [_c('div', [_vm._v("滑动开始图标（非必填）")]), _vm._v(" "), _c('UploadImage', {
    attrs: {
      "actionUrl": "/adminapi/v1/basicTools/upload/one?uploadImageType=3",
      "urls": _vm.formData.slideStartImg,
      "readonly": !_vm.isOperable
    },
    on: {
      "onUrls": _vm.slideStartImgUploaded
    }
  })], 1)])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "奖牌H5",
      "prop": "prizeUrl"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.isOperable
    },
    model: {
      value: (_vm.formData.prizeUrl),
      callback: function($$v) {
        _vm.$set(_vm.formData, "prizeUrl", $$v)
      },
      expression: "formData.prizeUrl"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动要求"
    }
  }, [_c('div', {
    staticClass: "flex-row"
  }, [_c('el-select', {
    staticStyle: {
      "width": "76px"
    },
    attrs: {
      "placeholder": "请选择类型",
      "disabled": !_vm.isOperable
    },
    on: {
      "change": _vm.changeRewardType
    },
    model: {
      value: (_vm.formData.rewardType),
      callback: function($$v) {
        _vm.$set(_vm.formData, "rewardType", $$v)
      },
      expression: "formData.rewardType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "次数",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "距离",
      "value": 2
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "36px"
    }
  }, [_vm._v(" 跑步")]), _vm._v(" "), _c('el-input-number', {
    staticStyle: {
      "width": "86px"
    },
    attrs: {
      "controls": false,
      "min": 0,
      "disabled": !_vm.isOperable
    },
    model: {
      value: (_vm.formData.rewardValue.threshold),
      callback: function($$v) {
        _vm.$set(_vm.formData.rewardValue, "threshold", $$v)
      },
      expression: "formData.rewardValue.threshold"
    }
  }), _vm._v(" "), (_vm.formData.rewardType == 1) ? _c('div', [_vm._v("次，获得奖励，每日计入一次")]) : _vm._e(), _vm._v(" "), (_vm.formData.rewardType == 2) ? _c('div', [_vm._v("米，获得奖励，每日最高计入")]) : _vm._e(), _vm._v(" "), (_vm.formData.rewardType == 2) ? _c('el-input-number', {
    staticStyle: {
      "width": "86px"
    },
    attrs: {
      "controls": false,
      "min": 0,
      "disabled": !_vm.isOperable
    },
    model: {
      value: (_vm.formData.rewardValue.oneDay),
      callback: function($$v) {
        _vm.$set(_vm.formData.rewardValue, "oneDay", $$v)
      },
      expression: "formData.rewardValue.oneDay"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.formData.rewardType == 2) ? _c('div', [_vm._v("米")]) : _vm._e()], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "默认展示奖牌图/徽章"
    }
  }, [_c('el-switch', {
    attrs: {
      "disabled": !_vm.isOperable,
      "on-text": "",
      "off-text": "",
      "active-text": ""
    },
    model: {
      value: (_vm.formData.showBadge),
      callback: function($$v) {
        _vm.$set(_vm.formData, "showBadge", $$v)
      },
      expression: "formData.showBadge"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "平台"
    }
  }, [_c('el-radio-group', {
    staticStyle: {
      "display": "flex",
      "line-height": "36px"
    },
    model: {
      value: (_vm.formData.osType),
      callback: function($$v) {
        _vm.$set(_vm.formData, "osType", $$v)
      },
      expression: "formData.osType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": -1,
      "disabled": !_vm.isOperable
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0,
      "disabled": !_vm.isOperable
    }
  }, [_vm._v("安卓")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1,
      "disabled": !_vm.isOperable
    }
  }, [_vm._v("iOS")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2,
      "disabled": !_vm.isOperable
    }
  }, [_vm._v("鸿蒙")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "适用学校"
    }
  }, [_c('el-radio-group', {
    staticStyle: {
      "display": "flex",
      "line-height": "36px"
    },
    on: {
      "change": _vm.changeCampus
    },
    model: {
      value: (_vm.formData.type),
      callback: function($$v) {
        _vm.$set(_vm.formData, "type", $$v)
      },
      expression: "formData.type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0,
      "disabled": !_vm.isOperable
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1,
      "disabled": !_vm.isOperable
    }
  }, [_vm._v("部分")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.formData.type ? '应用学校' : '屏蔽学校',
      "required": _vm.formData.type ? true : false,
      "prop": "rootUnids"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('el-select', {
    staticStyle: {
      "flex": "1",
      "margin-right": "8px"
    },
    attrs: {
      "placeholder": "请选择学校",
      "filterable": "",
      "disabled": !_vm.isOperable
    },
    model: {
      value: (_vm.schoolData),
      callback: function($$v) {
        _vm.schoolData = $$v
      },
      expression: "schoolData"
    }
  }, _vm._l((_vm.schoolDataSource), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": !_vm.isOperable
    },
    on: {
      "click": _vm.clickAddSchools
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-wrap"
  }, _vm._l((_vm.formData.rootUnids), function(item) {
    return _c('div', {
      key: item.value,
      staticClass: "card-item"
    }, [_c('span', [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "text",
        "icon": "circle-close",
        "disabled": !_vm.isOperable
      },
      on: {
        "click": function($event) {
          return _vm.clickDeleteSchools(item.value)
        }
      }
    })], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("共计" + _vm._s(_vm.formData.rootUnids.length) + "所学校")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "有效时间",
      "prop": "dateRange"
    }
  }, [_c('div', {
    staticClass: "flex-row-between"
  }, [_c('el-date-picker', {
    staticClass: "date-picker",
    attrs: {
      "type": "datetime",
      "placeholder": "起始日期",
      "disabled": !_vm.isOperable
    },
    model: {
      value: (_vm.formData.beginTime),
      callback: function($$v) {
        _vm.$set(_vm.formData, "beginTime", $$v)
      },
      expression: "formData.beginTime"
    }
  }), _vm._v(" "), _c('div', [_vm._v(" 至 ")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "date-picker",
    attrs: {
      "type": "datetime",
      "placeholder": "截止日期",
      "disabled": !_vm.isOperable
    },
    model: {
      value: (_vm.formData.endTime),
      callback: function($$v) {
        _vm.$set(_vm.formData, "endTime", $$v)
      },
      expression: "formData.endTime"
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选配"
    }
  }, [_c('div', [_vm._v("可部分上传，未上传的位置取默认配置")]), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("图片包")]), _vm._v(" "), _c('UploadFile', {
    attrs: {
      "actionUrl": "/adminapi/v1/basicTools/v650/file/upload?uploadImageType=3&fileType=2",
      "accept": ".zip",
      "tips": "按照对应位置状态命名，并打包成压缩包，仅支持.ZIP文件上传。 (ZIP包大小不超过600M)",
      "urls": _vm.formData.optionalImg,
      "readonly": !_vm.isOperable
    },
    on: {
      "onUrls": _vm.optionalImgUploaded
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "margin-top-10"
  }, [_vm._v("命名规则：点位+@2X；点位+@3X。一个点位需配置两套")]), _vm._v(" "), _c('div', [_vm._v("起点（img_point_start）终点（img_point_end）")]), _vm._v(" "), _c('div', [_vm._v("正常点置灰（img_point_normal）正常点亮（img_point_normal_pass）")]), _vm._v(" "), _c('div', [_vm._v("必经点置灰（img_point_must_normal）、必经点点亮（img_point_must_pass）")]), _vm._v(" "), _c('div', [_vm._v("点位1置灰（run_point_first_lock）、点位1准备中（run_point_first）")]), _vm._v(" "), _c('div', [_vm._v("点位2置灰（run_point_second_lock）、 点位2准备中（run_point_second）")]), _vm._v(" "), _c('div', [_vm._v("点位3置灰（run_point_third_lock）、点位3准备中（run_point_third）")]), _vm._v(" "), _c('div', [_vm._v("点位4置灰（run_point_fourth_lock）、点位4准备中（run_point_fourth）")]), _vm._v(" "), _c('div', [_vm._v("点位5置灰（run_point_fifth_lock）、点位5准备中（run_point_fifth）")]), _vm._v(" "), _c('div', [_vm._v("分配终点（img_point_assign_end_normal）")]), _vm._v(" "), _c('div', [_vm._v("分配终点经过（img_point_assign_end_pass）")])], 1), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("音频")]), _vm._v(" "), _c('UploadFile', {
    attrs: {
      "actionUrl": "/adminapi/v1/basicTools/v650/file/upload?uploadImageType=3&fileType=2",
      "accept": ".zip",
      "tips": "按照位置命名，并打包成压缩包，仅支持.ZIP文件上传。 (ZIP包大小不超过600M)",
      "urls": _vm.formData.optionalVideo,
      "readonly": !_vm.isOperable
    },
    on: {
      "onUrls": _vm.optionalVideoUploaded
    }
  }), _vm._v(" "), _c('div', [_vm._v("命名规则：将图片按位置命名（位置）")]), _vm._v(" "), _c('div', [_vm._v("位置：")]), _vm._v(" "), _c('div', [_vm._v("跑步开始（run_start）、必经点（run_fixed）、终点（run_destination）、")]), _vm._v(" "), _c('div', [_vm._v("暂停（run_pause）、重新开始（run_resume）、完成跑步（run_finish）、")]), _vm._v(" "), _c('div', [_vm._v("点位1（run_ordinary1）、点位2（run _ordinary2）、")]), _vm._v(" "), _c('div', [_vm._v("点位3（run_ordinary3）、点位4（run_ordinary4）")])], 1)])], 1)], 1), _vm._v(" "), (_vm.isOperable) ? _c('div', {
    staticClass: "margin-20"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.clickSave()
      }
    }
  }, [_vm._v("保存")])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0e053718!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/Activity/ThemeRunning/ThemeDetail.vue
// module id = 940
// module chunks = 0